export default function LoggedOutPage() {
  return (
    <div className="min-h-screen bg-surface-950 flex items-center justify-center p-4">
      <div className="flex flex-col items-center gap-6 text-center max-w-sm w-full">
        <div className="w-14 h-14 rounded-full bg-surface-900 border border-surface-700 flex items-center justify-center">
          <svg
            className="w-7 h-7 text-surface-400"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={1.5}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M15.75 9V5.25A2.25 2.25 0 0013.5 3h-6a2.25 2.25 0 00-2.25 2.25v13.5A2.25 2.25 0 007.5 21h6a2.25 2.25 0 002.25-2.25V15m3 0l3-3m0 0l-3-3m3 3H9"
            />
          </svg>
        </div>
        <div>
          <h1 className="text-xl font-semibold text-surface-100 mb-1">You've been signed out</h1>
          <p className="text-sm text-surface-400">
            Your session has ended. Sign in again to access the dashboard.
          </p>
        </div>
        <a href="/login" className="btn-primary w-full text-center">
          Sign in
        </a>
      </div>
    </div>
  );
}
